export function loadingStart() {
  let loadingScreenContainer = document.getElementById("loading-container");
  if (loadingScreenContainer) {
    return;
  }

  document.body.classList.add("page-loading");
}

export function loadingEnd(callback) {
  setTimeout(() => {
    document.body.classList.add("page-loading--hide");
    callback();
  }, 1500);

  setTimeout(() => {
    document.body.classList.remove("page-loading--hide");
    document.body.classList.remove("page-loading");
    //loadingScreenContainer.remove();
    $.post("/preloading", { preloading: 1 });
  }, 2500);
}
